import styled from "styled-components";
import { Search } from "styled-icons/material/Search";

export const Container = styled.div`
  border: 20px solid #F5F5F5;
  height: auto;
  justify-content: center;
  flex-direction: column;
  padding: var(--spacing-default);
  font-family: Avenir;
  font-size: 18px;
  line-height: 25px;
  .title{
    font-weight: 700;
    margin-bottom: var(--size-medium);
  }
  .head {
    background-color: #eee;
    color: #66757f;
    font-family: Avenir;
    height: 45px;
    display: flex;
    align-items: center;
  }
  .div-menu, .div-data, .div-play {
    align-items: center;
    display: flex;
  }
  .div-menu{
    justify-content: flex-end;
  }
  .ep{
    display: flex;
    flex-direction: row;
    margin-bottom: var(--size-small);

    .episode-card{
      flex:4;
    }
    .menu-gerente{
      font-family: Avenir;
      font-size: 14px;
      line-height: 10px;
      color: #2196F3;
      flex:1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      span{
        margin-left: var(--size-small);
        :last-child{
          color: #EB5757;
        }
      }
    }
  }
  @media (max-width: 992px) {
    border: 10px solid #F5F5F5;
    padding: var(--spacing-medium);
  }
`;

export const SearchIcon = styled(Search)`
  color: var(--color-third-darken);
  height: var(--size-medium);
  right: var(--size-small);
`;

export const WrapperSearch = styled.article`
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: var(--size-small);
  border-bottom: 1px solid #66757F;

  .inputSearch {
    border: none;
    border-radius: var(--radius-medium);
    width: auto;
    flex: 3;
  }
  .drop{
    flex:2;
    color: #66757F;
    font-size: 13px;
  }
  
`;
